export const firebaseConfig = {
    apiKey: "AIzaSyB4NiJbyAqTnyJw9pVhnGJC5c7xL7PeTrI",
    authDomain: "duijvelaar-pompen-select.firebaseapp.com",
    databaseURL: "https://duijvelaar-pompen-select.firebaseio.com",
    projectId: "duijvelaar-pompen-select",
    storageBucket: "duijvelaar-pompen-select.appspot.com",
    messagingSenderId: "999520052707"
  };
